function throwOnUndefinedProperty(obj) {
  var handler = {
    get(target, property) {
      if (property === '__isProxy') {
        return true;
      }

      if (property in target) {
        return target[property];
      } // Allow React-Fast-Refresh to check if objects are components


      if (property === '$$typeof') {
        return;
      }

      throw new Error("Property '".concat(property, "' is not defined"));
    }

  };
  return new Proxy(obj, handler);
}

export { throwOnUndefinedProperty as default };
